import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import JobCard from './JobCard';
import { API_BASE_URL } from '../config/apiConfig';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './JobCardCarousel.css';

const JobCardCarousel = () => {
  const [carouselJobs, setCarouselJobs] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/jobs?limit=1000`);
        const data = await response.json();
        setCarouselJobs(data.jobs || []);
      } catch (error) {
        setCarouselJobs([]);
      }
    };

    fetchJobs();
  }, []);

  // Filter jobs that are expiring soon (within 5 days)
  const now = new Date();
  const expiringSoonJobs = carouselJobs.filter(job => {
    const lastDate = new Date(job.lastDate);
    const daysLeft = Math.ceil((lastDate - now) / (1000 * 60 * 60 * 24));
    return daysLeft >= 0 && daysLeft <= 5;
  });

  return (
    <div className="job-carousel-wrapper">
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        autoPlay
        emulateTouch
        swipeable
        centerMode
        centerSlidePercentage={100}
        renderArrowPrev={(clickHandler, hasPrev) =>
          hasPrev && (
            <button className="carousel-arrow left" onClick={clickHandler}>
              ⬅
            </button>
          )
        }
        renderArrowNext={(clickHandler, hasNext) =>
          hasNext && (
            <button className="carousel-arrow right" onClick={clickHandler}>
              ➡
            </button>
          )
        }
      >
        {expiringSoonJobs.map(job => (
          <div key={job._id} className="carousel-slide">
            <JobCard job={job} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default JobCardCarousel;
